import Highcharts from 'highcharts'
import { HighchartsReact } from 'highcharts-react-official'

const ColumnHighChart = () => {
  const options = {
    chart: {
      type: 'column',
      height: 245,
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
    },
    yAxis: {
      title: {
        text: 'Valor',
      },
    },
    series: [
      {
        name: 'Lucro',
        data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      },
      {
        name: 'Despesas',
        data: [12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
      },
    ],
    credits: {
      enabled: false,
    },
  }

  return <HighchartsReact highcharts={Highcharts} options={options} />
}

export default ColumnHighChart
